import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import VisIcon from '../../../images/submenu_open copy 6.png'
import NavigateIcon from '../../../images/submenu_open copy 5.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'
import WarningIcon from '../../../images/advarsel2.png'

class MatrikkelenhetSimple extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleMatrikkelenhet = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    navigateMatrikkelenhet = (event) => {
        event.stopPropagation()
        this.props.onMatrikkelObjectSelected({
            domainKlasse: "Matrikkelenhet",
            matrikkelenhet: this.props.matrikkelenhet
        })
    }

    showMatrikkelenhet = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowMatrikkelenhet,
                matrikkelenhet: this.props.matrikkelenhet
            }
        })
    }

    render() {
        const { t } = this.props
        var matrikkelenhet = this.props.matrikkelenhet
        var matrikkelnummer = `${matrikkelenhet.gardsnummer}/${matrikkelenhet.bruksnummer}`;
        if (matrikkelenhet.festenummer || matrikkelenhet.seksjonsnummer) matrikkelnummer += `/${matrikkelenhet.festenummer}/${matrikkelenhet.seksjonsnummer}`;
        var infoList = []
        if (matrikkelenhet.utgatt) infoList.push(t('utgatt'))
        if (!matrikkelenhet.harTeig) infoList.push(t('manglerteig'))        

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleMatrikkelenhet}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{matrikkelenhet.kommuneId}-{matrikkelnummer}</span>
                    { infoList.length > 0 &&
                    <div className="icon-image tooltip warning">
                        <img src={WarningIcon} />
                        <div className="tooltip-content">
                            {infoList.map((i, index) => { return (<div key={index}>{i}</div>) })}
                        </div>
                    </div> }
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    <div className="icon-image right tooltip" onClick={this.navigateMatrikkelenhet}>
                        <img className="tool" src={NavigateIcon} />
                        <div className="tooltip-content">{t('naviger.matrikkelenhet', { domeneklasse: matrikkelenhet.domeneklasse.toLowerCase()})}</div>
                    </div>
                    { matrikkelenhet.harTeig &&
                    <div className="icon-image right tooltip" onClick={this.showMatrikkelenhet}>
                        <img className="tool" src={VisIcon} />
                        <div className="tooltip-content">{t('vis.matrikkelenhet', { domeneklasse: matrikkelenhet.domeneklasse.toLowerCase()})}</div>
                    </div> }
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{matrikkelenhet.kommunenavn} ({matrikkelenhet.kommuneId})</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('eiendom')}</div>
                            <div className="value">{matrikkelnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('eiendomstype')}</div>
                            <div className="value">{matrikkelenhet.domeneklasse}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(MatrikkelenhetSimple)
